import { render, staticRenderFns } from "./IcoIHexagon.vue?vue&type=template&id=18a74c2b"
import script from "./IcoIHexagon.vue?vue&type=script&lang=js"
export * from "./IcoIHexagon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports